import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  connect() {
    this.element.scrollTop = this.element.scrollHeight
  }

  itemTargetConnected(element) {
    this.element.scrollTop = this.element.scrollHeight
  }
}
